import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  LayoutDashboard, 
  Users, 
  Wrench, 
  FileText, 
  Receipt,
  User,
  Plus,
  Zap,
  CreditCard,
  LogOut,
  ExternalLink
} from 'lucide-react';

const navItems = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Tableau de bord' },
  { path: '/clients', icon: Users, label: 'Clients' },
  { path: '/services', icon: Wrench, label: 'Catalogue' },
  { path: '/quotes', icon: FileText, label: 'Devis' },
  { path: '/invoices', icon: Receipt, label: 'Factures' },
  { path: '/profile', icon: User, label: 'Profil' },
  { path: '/subscription', icon: CreditCard, label: 'Abonnement' }
];

export const BottomNav = () => {
  const location = useLocation();
  
  if (location.pathname === '/quotes/new' || 
      location.pathname.match(/^\/quotes\/[^/]+$/) ||
      location.pathname.match(/^\/invoices\/[^/]+$/)) {
    return null;
  }
  return (
    <nav className="bottom-nav md:hidden" data-testid="bottom-nav">
      {navItems.filter(item => item.path !== '/subscription').map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`nav-${item.path.replace('/', '') || 'home'}`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs mt-1">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, canWrite } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="desktop-sidebar" data-testid="sidebar">
      {/* Logo */}
      <div className="mb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center">
            <Zap className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="text-xl font-bold tracking-tight uppercase">DevisFast</span>
        </div>
      </div>

      {/* New Quote Button */}
      <button
  onClick={() => navigate(canWrite() ? '/quotes/new' : '/subscription')}
  className="flex items-center justify-center gap-2 w-full h-12 bg-primary text-primary-foreground hover:bg-accent font-bold uppercase tracking-wide rounded-full mb-6 transition-colors"
  data-testid="sidebar-new-quote"
>
  <Plus className="w-5 h-5" />
  Nouveau devis
</button>

      {/* Nav Items */}
      <nav className="space-y-1 flex-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? 'bg-primary/20 text-primary' 
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
              data-testid={`sidebar-${item.path.replace('/', '') || 'home'}`}
            >
              <Icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="mt-auto pt-6 border-t border-white/10">
        <a
          href="https://devisfast.fr/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 w-full px-4 py-2 mb-1 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
        >
          <ExternalLink className="w-4 h-4" />
          <span className="text-sm font-medium">Site web</span>
        </a>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 w-full px-4 py-2 mb-3 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
          data-testid="sidebar-logout"
        >
          <LogOut className="w-4 h-4" />
          <span className="text-sm font-medium">Se déconnecter</span>
        </button>
        <p className="text-xs text-muted-foreground">DevisFast v1.0</p>
        <p className="text-xs text-muted-foreground">Devis & factures pour artisans</p>
      </div>
    </aside>
  );
};
